import { StudyStatusesEnum } from "../api/study"
import {FeatureFlagsEnum} from "../context/useFlags";

export const studiesList = [
    {
        value: "holter",
        label: "Holter"
    },
    {
        value: "two_week_holter",
        label: "Multi-Holter"
    },
    {
        value: "rpm",
        label: "Mawi Watch"
    }
]

export const studyStatuses = [
    {
        value: StudyStatusesEnum.not_enrolled,
        label: "Not enrolled"
    },
    {
        value: StudyStatusesEnum.inprogress,
        label: "In progress"
    },
    {
        value: StudyStatusesEnum.interpretating,
        label: "Interpreting"
    },
    {
        value: StudyStatusesEnum.in_review,
        label: "In review"
    },
    {
        value: StudyStatusesEnum.completed,
        label: "Completed"
    },
    {
        value: StudyStatusesEnum.upload_overdue,
        label: "Upload overdue"
    },
    {
        value: StudyStatusesEnum.processing_stalled,
        label: "Processing stalled"
    },
    {
        value: StudyStatusesEnum.archived,
        label: "Archived"
    }
]

export const studyStatusesInbox = [
    {
        value: StudyStatusesEnum.interpretating,
        label: "Interpreting"
    },
    {
        value: StudyStatusesEnum.in_review,
        label: "In review"
    },
    {
        value: StudyStatusesEnum.processing_stalled,
        label: "Processing stalled"
    }
]

export const allStudyStatuses = [
    {
        value: StudyStatusesEnum.draft,
        label: "Draft"
    },
    ...studyStatuses
]

export const languages = [
    {
        value: "EN",
        label: "English(EN)"
    },
    {
        value: "UK",
        label:"Ukrainian(UK)"
    }
]

export const studySeverities = [
    {
        value: "1",
        label: "Level 1"
    },
    {
        value: "2",
        label: "Level 2"
    },
    {
        value: "3",
        label: "Level 3"
    }
]

export const analysisPlatforms = [
    {
        value: 'amps',
        label: 'AMPS',
    },
    {
        value: 'amps_cers',
        label: 'CER-SCor',
    }
]

export const featureFlagsList = [
    {
        value: FeatureFlagsEnum.RAW_DATA_ACCESS,
        label: 'Raw data view - Clinicans access to review raw data(CER-SCor)',
    },
    {
        value: FeatureFlagsEnum.DMS_WEB_ENROLLMENT,
        label: "Web enrollment - Clinicians access to enroll devices via Web(DMS)"
    },
    {
        value: FeatureFlagsEnum.IS_AUTO_SIGN,
        label: "Auto-signing - Once the report is received, the study will be signed by the system and its status will be changed to 'Completed'"

    }
]

export const NO_PERMISSIONS_MESSAGE = "You haven't permissions to see this page";
